/*
  Footer component for FullStack.cash
*/

import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'

function Footer () {
  return (
    <footer className='bg-dark text-light py-4 mt-auto'>
      <Container>
        <Row>
          <Col md={6} className='text-center text-md-start mb-3 mb-md-0'>
            <ul className='list-inline mb-0'>
              <li className='list-inline-item me-3'>
                <a
                  href='https://t.me/permissionless_software'
                  target='_blank'
                  rel='noreferrer'
                  className='text-light text-decoration-none'
                >
                  <i className='fab fa-telegram me-2' />Telegram
                </a>
              </li>
              <li className='list-inline-item me-3'>
                <a
                  href='https://github.com/Permissionless-Software-Foundation'
                  target='_blank'
                  rel='noreferrer'
                  className='text-light text-decoration-none'
                >
                  <i className='fab fa-github me-2' />GitHub
                </a>
              </li>
              <li className='list-inline-item'>
                <Link to='/contact' className='text-light text-decoration-none'>
                  <i className='fas fa-envelope me-2' />Email
                </Link>
              </li>
            </ul>
          </Col>
          <Col md={6} className='text-center text-md-end'>
            <p className='mb-0 small'>
              An initiative of the{' '}
              <a
                href='https://psfoundation.cash/'
                target='_blank'
                rel='noreferrer'
                className='text-light'
              >
                Permissionless Software Foundation
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
